"use client";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white text-gray-800">
      <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
      <p className="text-sm text-gray-500 mb-6">An unexpected error occurred.</p>
      <button
        onClick={reset}
        className="px-6 py-2 bg-blue-600 text-white rounded text-sm font-medium hover:bg-blue-700"
      >
        Try again
      </button>
    </div>
  );
}
